module.exports = __webpack_public_path__ + "static/image-nos-usine-b7c5c17f38a1b182dd4051e576a6b189.png";